module.exports = __webpack_public_path__ + "img/ttnhandler.9eed33ca.png";